import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Alternativa = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Alternativas de Custo Médio</div></Card.Header>
        <Card.Body>
          {/* <Card.Title></Card.Title> */}
          <Card.Text>
          <div className="opcoes">
              <strong>Desempenho Inferior: </strong>
              Não oferecem o mesmo nível de velocidade e capacidade 
              que os modelos de alto desempenho, podendo sofrer em 
              ambientes com alta densidade de dispositivos.
            </div> 
            <div className="opcoes">
              <strong>Falta de Suporte para Tecnologias Mais Novas: </strong>
              Geralmente não suportam as tecnologias mais recentes, como Wi-Fi 6, 
              resultando em desempenho e segurança inferiores.
            </div> 
            <div className="opcoes">
              <strong>Cobertura Limitada: </strong>
              Podem enfrentar dificuldades para fornecer cobertura adequada em 
              grandes áreas ou em locais com muitas barreiras físicas.
            </div>                      
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        {/* <Card.Footer className="text-muted">
        Para garantir uma decisão acertiva ao investir em equipamentos de rede Wi-Fi, é essencial analisar e 
        ponderar o investimento com base nas necessidades específicas de cada cenário
        </Card.Footer> */}
      </Card>
    </>
  )
}
export default Alternativa;